import React from 'react';

export const DuplicateTestAlertModal = ({ test, parentProfileName, onCancel, onConfirmAdd }) => {
  if (!test) return null;

  return (
    <div className="pkg-modal-backdrop" onClick={onCancel} role="dialog" aria-modal="true">
      <div className="pkg-alert-modal fade-in" onClick={(e) => e.stopPropagation()}>
        <div className="pkg-alert-icon">⚠️</div>
        <div className="pkg-alert-content">
          <h3 className="pkg-alert-title">Test Already Included</h3>
          <p className="pkg-alert-text">
            <strong>{test.name || test.investigationName || test.code}</strong> is already included in this package through the <strong>{parentProfileName}</strong> Profile.
          </p>
          <div className="pkg-alert-tip">
            Adding it directly may duplicate the test on the patient report unless required for separate billing.
          </div>
        </div>

        <div className="pkg-alert-actions">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="btn btn-warning" onClick={onConfirmAdd}>
            Add Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateTestAlertModal;
